import React, { useEffect, useState } from "react";
import OfflineMessage from "./OfflineMessage";

/**
 * Shows an offline banner only when the browser reports no network.
 *
 * Do not probe third-party hosts (e.g. Google). Those requests fail on
 * corporate firewalls, regional blocks, and privacy tools while the app
 * itself remains reachable — which falsely looks like an app outage.
 */
function DetectInternet({ children }) {
    const [isOnline, setIsOnline] = useState(
        typeof navigator !== "undefined" ? navigator.onLine : true
    );

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        // Sync in case status changed before listeners were attached
        setIsOnline(navigator.onLine);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);

    return (
        <>
            {!isOnline && (
                <OfflineMessage message={"Your internet connection is lost."} />
            )}
            {children}
        </>
    );
}

export default DetectInternet;
